import Vue from 'vue';
import { HTTP_GET } from "../const";
import {
  LOAD_HANDLER_ACCOUNTS_LIST,
  LOAD_HANDLERS_INFO,
  RESET_HANDLERS
} from "../const/handlers";

export default {
  namespaced: true,
  state: {
    handlers: {},
    handlerAccounts: {},
  },
  getters: {
    handlers: state => state.handlers,
    handlerAccounts: state => state.handlerAccounts,
  },
  actions: {
    [LOAD_HANDLERS_INFO]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_HANDLERS_INFO,
        namespace: 'handlers',
      }, {root: true});
    },
    [LOAD_HANDLER_ACCOUNTS_LIST]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_HANDLER_ACCOUNTS_LIST,
        namespace: 'handlers',
      }, {root: true});
    },
  },
  mutations: {
    [LOAD_HANDLERS_INFO]: (state, { data }) => {
      Vue.set(state, 'handlers', data);
    },
    [LOAD_HANDLER_ACCOUNTS_LIST]: (state, { data }) => {
      Vue.set(state, 'handlerAccounts', data);
    },
    [RESET_HANDLERS]: (state) => {
      Vue.set(state, 'handlers', []);
    },
  },
};
